import type { Cadeia, PalavraCanonica } from '../tipos';
import type { EstadoLetra } from './avaliacao';
import { indiceDoDia } from './dia';
import { marcasDaCadeia, palavrasDoJogador } from './partida';

/**
 * A grade de quadradinhos (§23.6).
 *
 * É o que fez o Wordle se espalhar, e funciona por uma razão só: **não conta
 * nada**. Mostra o formato do raciocínio — onde se acertou, onde se chegou
 * perto — sem revelar uma letra sequer. Quem ainda não jogou pode ler o texto
 * inteiro sem ter o dia estragado.
 *
 * Aqui as linhas têm tamanhos diferentes, porque as palavras do jogador têm
 * (§23.3). Isso é informação a mais que o Termo não dá — dá para ver que a
 * pessoa entrou com uma palavra longa —, e continua não sendo a palavra.
 */

const QUADRADO: Readonly<Record<EstadoLetra, string>> = {
  certa: '🟩',
  presente: '🟨',
  ausente: '⬛',
};

export function linhaCompartilhavel(letras: readonly EstadoLetra[]): string {
  return letras.map((estado) => QUADRADO[estado]).join('');
}

/**
 * Onde o jogo mora. Vai na última linha do texto compartilhado: quem recebe a
 * grade de quadradinhos não tem como saber de onde ela veio, e um resultado
 * que não diz onde se joga é um convite sem endereço.
 */
export const ENDERECO = 'entreletras.io';

/** Só as linhas de quadradinhos, sem cabeçalho nem endereço. */
export function gradeCompartilhavel(
  cadeia: Cadeia,
  resposta: PalavraCanonica | undefined,
): readonly string[] {
  const marcas = marcasDaCadeia(cadeia, resposta);
  return palavrasDoJogador(cadeia).map((palavra) =>
    linhaCompartilhavel(marcas.get(palavra.id) ?? []),
  );
}

/**
 * Texto pronto para colar. `X` quando o dia foi abandonado sem resposta.
 *
 * Sem contagem de palavras: §23.1 tirou o placar da Trama, e um cabeçalho que
 * dissesse `2 palavras` o traria de volta pela porta dos fundos — quem recebe
 * o texto compararia números, que é exatamente o que o modo não cobra.
 */
export function textoCompartilhavel(
  cadeia: Cadeia,
  dia: string,
  resposta: PalavraCanonica | undefined,
  descobriu: boolean,
): string {
  const numero = indiceDoDia(dia) + 1;
  const cabecalho = descobriu ? `Trama ${numero}` : `Trama ${numero} — X`;
  return [cabecalho, '', ...gradeCompartilhavel(cadeia, resposta), '', ENDERECO].join('\n');
}
